import { useEffect, useRef, useCallback, useState } from 'react';
import io from 'socket.io-client';

export function useSocket() {
    const socketRef = useRef(null);
    const [connected, setConnected] = useState(false);
  
    const connect = useCallback((idUser) => {
      if (socketRef.current?.connected) return;
  
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }

      try {
        const socket = io(process.env.REACT_APP_WEBSOCKET_URL, {
          path: '/socket.io',
          transports: ['websocket'],
          query: { idUser },
        });

        socket.on('connect', () => {
          setConnected(true);
        });

        socket.on('disconnect', (reason) => {
          setConnected(false);
          if (reason === 'io server disconnect') {
            setTimeout(() => socket.connect(), 1000);
          }
        });

        socket.on('connect_error', (error) => {
          console.error('❌ Error de conexión al socket:', error);
          setConnected(false);
        });

        socketRef.current = socket;
        return socket;
      } catch (error) {
        console.error('Error al crear el socket:', error);
        setConnected(false);
        return null;
      }
    }, []);
  
    const disconnect = useCallback(() => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
        setConnected(false);
      }
    }, []);
  
    const on = useCallback((event, callback) => {
      if (!socketRef.current) {
        console.warn('Socket no inicializado');
        return () => {};
      }
      
      socketRef.current.on(event, callback);
      return () => socketRef.current?.off(event, callback);
    }, []);
  
    const emit = useCallback((event, data, callback) => {
      if (socketRef.current) {
        return socketRef.current.emit(event, data, callback);
      }
      return false;
    }, []);
  
    useEffect(() => {
      return () => {
        if (socketRef.current) {
          socketRef.current.disconnect();
        }
      };
    }, []);
  
    return {
      connect,
      disconnect,
      on,
      emit,
      connected,
    };
}